import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { loadSavedTheme } from "./utils/themes";
import { loadSavedFont } from "./utils/fonts";
import { NavigationService } from "./NavigationService";
import Home from "./public/Home";
import Services from "./public/Services";
import About from "./public/About";
import Bookshelf from "./public/Bookshelf";
import Contact from "./public/Contact";
import Privacy from "./public/Privacy";
import Terms from "./public/Terms";

function App() {
  useEffect(() => {
    loadSavedTheme();
    loadSavedFont();
  }, []);

  return (
    <BrowserRouter>
      <NavigationService />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/bookshelf" element={<Bookshelf />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>
    </BrowserRouter>
  );
};

export default App;
